import { UnidadeDeMedida } from "../../../enums/UnidadeDeMedida";
import styles from "../styles.module.css";

type Props = {
  title: string;
  value: any;
  setter?: Function;
  hideAsterisk?: boolean;
  required?: boolean;
  children: any;
};

const CampoSelect = ({
  title,
  value,
  setter,
  hideAsterisk,
  children,
  required,
}: Props) => {
  return (
    <div className={styles.campo}>
      <label className={styles.title}>
        {title}
        <span className={styles.required}>{!hideAsterisk && "*"}</span>:
      </label>
      <select
        className={setter ? "" : styles.borderNone}
        disabled={setter ? false : true}
        value={value}
        required={required}
        onChange={
          setter &&
          ((e) => {
            const v = e.target.value;
            setter(v);
            e.currentTarget.setCustomValidity("");
          })
        }
      >
        {children}
      </select>
    </div>
  );
};

export default CampoSelect;
